// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxSquareFilledSvg from "@ant-design/icons-svg/es/asn/DropboxSquareFilled";
import AntdIcon from '../components/AntdIcon';

var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxSquareFilledSvg
  }));
};

DropboxSquareFilled.displayName = 'DropboxSquareFilled';
export default React.forwardRef(DropboxSquareFilled);